import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintcheck = () => {
  const title = "Checkstep as AI moderation who are at the forefront of online safety.";
  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            Checkstep as AI moderation who are at the forefront of online
            safety.
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on June, 2024</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                {BRAND.domainLabel} has partnered with Checkstep to lead the
                platform&apos;s AI-driven content moderation efforts. Checkstep
                brings cutting-edge moderation capabilities across text, video,
                image, and audio, helping ensure that all content on
                {BRAND.domainLabel} aligns with its community guidelines.
              </p>

              <p>
                This partnership reinforces {BRAND.domainLabel}&apos;s commitment to
                user safety by preventing the spread of harmful, inappropriate,
                or unsafe content. It marks a significant milestone in the
                platform&apos;s ongoing efforts to build a secure, responsible,
                and inclusive digital environment.
              </p>

              <p>
                By integrating Checkstep&apos;s advanced technology with the
                expertise of Modsquad&apos;s human moderators, {BRAND.domainLabel} has
                established an industry-leading two-tier moderation system. This
                dual approach combines the speed and scalability of artificial
                intelligence with the nuanced judgment of human oversight.
              </p>

              <p>
                Together, these systems work to safeguard users, uphold
                community standards, and foster a more positive experience for
                everyone on {BRAND.domainLabel}.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintcheck;
